module.exports = __webpack_public_path__ + "static/media/stop.6212638f.svg";